<template>
  <div>
    <p class="mt-4" ref="title">
      <b>{{ component.label }}</b>
    </p>
    <v-list three-line>
      <v-list-tile v-for="(item, index) in selectedItems" :key="index">
        <v-list-tile-content>
          <v-list-tile-sub-title>
            {{ item.text }} ({{ item.code }})
          </v-list-tile-sub-title>
          <v-list-tile-sub-title v-if="item.selectedSynonym">
            <small>{{item.selectedSynonym}}</small>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="removeItem(item)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider v-if="value.length"></v-divider>
      <v-list-tile v-if="!showEditorPane && selectedItems.length < maxEntries">
        <v-list-tile-content>
          <v-list-tile-title @click="showPane()"> Adicionar </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="showPane()">
            <v-icon color="primary">add_circle</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <div class="px-3 card-rounded border grey--border" v-if="showEditorPane">
      <Icd11Input v-model="diagnosis" />

      <v-switch
        class="mt-0"
        hide-details
        v-if="diagnosis && diagnosis.synonym"
        v-model="showSynonyms"
        :label="diagnosis.synonym.length + ' Matching Terms:'"
      ></v-switch>

      <template v-if="diagnosis && diagnosis.synonym && showSynonyms">
        <v-radio-group class="mt-1 synonym" v-model="diagnosis.selectedSynonym">
          <v-radio
            v-for="(item, key) in diagnosis.synonym"
            :key="key"
            :value="item"
          >
            <template slot="label">
              <span class="pb-1" :key="'s'+key" v-html="item"></span>
            </template> 
          </v-radio>
        </v-radio-group>
        <!-- <v-list dense v-for="(item, key) in diagnosis.synonym" :key="key">
          <v-list-tile>{{item}}</v-list-tile>
        </v-list> -->
      </template>
      <v-layout wrap class="my-2">
        <v-btn
          class="ml-0"
          small
          v-if="paneIndex === null"
          color="primary"
          :disabled="!diagnosis"
          @click="addItem()"
          >Adicionar</v-btn
        >
      </v-layout>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Icd11Input from '../../../components/inputs/Icd11Input'

export default {
  props: {
    value: { type: Array, default: () => [] },
    component: { type: Object },
    logbook: { type: String },
    maxEntries: { type: Number }
  },
  components: {
    Icd11Input
  },
  data() {
    return {
      loading: false,
      item: null,
      selection: null,
      items: [],
      search: null,
      selectedItems: [],
      paneIndex: null,
      showEditorPane: false,
      diagnosis: null,
      showSynonyms: false
    }
  },
  watch: {
    search(newval) {
      if (newval && newval !== this.value) {
        this.items = []
      }
    }
  },
  created() {
    if (this.value) {
      this.selectedItems = this.value
    }
  },

  methods: {
    showPane(item = null, index = null) {
      if (item) {
        this.paneIndex = index
        this.diagnosis = item
      } else {
        this.paneIndex = null
      }
      this.showEditorPane = true
    },
    selectItem(target) {
      if (!target) {
        this.item = {}
        return
      }
      this.item = this.items.find(
        ({ long_description }) => long_description == target
      )
    },
    emitUpdate(newItems) {
      this.$emit('input', newItems)
    },

    removeItem(item) {
      if (this.paneIndex !== null) {
        this.paneIndex = null
        this.showEditorPane = false
      }
      this.selectedItems = this.selectedItems.filter(element => element != item)

      this.emitUpdate(this.selectedItens)
    },
    addItem() {
      if (this.diagnosis) {
        this.diagnosis.selectedSynonym ? this.diagnosis.selectedSynonym = this.diagnosis.selectedSynonym.replaceAll("<em class='found'>", "") : ''
        this.diagnosis.selectedSynonym ? this.diagnosis.selectedSynonym = this.diagnosis.selectedSynonym.replaceAll('</em>', '') : ''
        this.selectedItems.push(this.diagnosis)
        this.emitUpdate(this.selectedItems)

        this.showEditorPane = false
        this.diagnosis = ''
      }
    },
    editItem() {
      if (this.diagnosis) {
        this.selectedItems.splice(this.paneIndex, 1, this.diagnosis)
        this.emitUpdate(this.selectedItems)

        this.showEditorPane = false
        this.diagnosis = ''
      }
    },
    cancel() {
      this.showEditorPane = false
      this.paneIndex = null
      this.diagnosis = ''
    }
  }
}
</script>

<style>
em {
  font-style: normal !important;
  font-weight: 700 !important;
}
div.icd-autocomplete a {
  height: 100%;
}
.synonym .accent--text .theme--light.v-label {
  color: initial;
}
</style>
